<template>
  <div class="flex justify-center font-roboto table-responsive">
    <table class="w-full border-separate border-spacing-y-1 ">
      <thead>
        <tr class="rounded-lg border border-white shadow-[0_0_10px_0_#00000026]">
          <th v-for="(header, index) in headers" :key="header.key" class="p-2 font-light text-[16px]" :class="{
            'rounded-l-lg': index === 0,
            'rounded-r-lg': index === headers.length - 1,
            'bg-[#BA90C6] text-white': true
          }">
            {{ header.text }}
          </th>
        </tr>
      </thead>
      <tbody class="bg-white text-slate-800 table-row-group space-y-2 w-full">
        <tr v-for="(item, rowIndex) in items" :key="rowIndex" class="mt-1 border-0 py-2 text-sm rounded-lg shadow-[0_0_10px_0_#00000026]">
          <td v-for="(header, colIndex) in headers" :key="header.key" class="p-2 bg-white" :class="{
            'rounded-l-lg': colIndex === 0,
            'rounded-r-lg': colIndex === headers.length - 1
          }">
            <template v-if="header.key === 'status'">
              <span class="text-white rounded-md px-3 py-1" :class="getStatusClass(item[header.key])">
                {{ item[header.key] }}
              </span>
            </template>
            <template v-else-if="header.key === 'textStatus'">
              <span :class="getTextStatusClass(item[header.key])">
                {{ item[header.key] }}
              </span>
            </template>
            <template v-else-if="header.key === 'image'">
              <img v-if="item[header.key]" :src="item[header.key]" class="w-10 h-10 object-contain"
                :alt="`Image for ${item.name || item.id}`" />
              <span v-else>-</span>
            </template>
            <template v-else>
              {{ item[header.key] }}
            </template>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    headers: {
      type: Array,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    }
  },
  methods: {
    getStatusClass(status) {
      const statusClasses = {
        'Paid': 'bg-lime-600',
        'Pending': 'bg-amber-500',
        'Failed': 'bg-rose-600'
      };
      return statusClasses[status] || 'bg-gray-500';
    },
    getTextStatusClass(textStatus) {
      const textStatusClasses = {
        'Evaluation Completed': 'text-cyan-500',
        'Inspection Started': 'text-blue-500',
      };
      return textStatusClasses[textStatus];
    }
  }
};
</script>
